const $ = window.jQuery;

if ( $( '.ufaq-faq-category-title' ).length ) {

	$( '.ufaq-faq-category-body-hidden' ).eq(0).removeClass( 'ufaq-faq-category-body-hidden' );
	$( '.ufaq-faq-category-title' ).eq(0).addClass( 'open' );

	$( 'body' ).on( 'click', '.ufaq-faq-category-title', function() {

		if ( $( this ).hasClass( 'open' ) ) {
			$( this ).removeClass( 'open' );
			return;
		}

		$( '.ufaq-faq-category-title' ).removeClass( 'open' );
		$( this ).addClass( 'open' );
	} );

}
